import { useCallback, useSyncExternalStore } from "react";

interface SessionStore<T> {
  getSession(): T;
  subscribeSession(listener: () => void): () => void;
}

// 保留 runtime 方法的 this，并仅在 runtime 更换时重新订阅。
export function useRuntimeSession<T>(runtime: SessionStore<T>): T {
  const subscribe = useCallback(
    (listener: () => void) => runtime.subscribeSession(listener),
    [runtime],
  );
  const getSnapshot = useCallback(() => runtime.getSession(), [runtime]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
